let BrowserDetect = () => {
    if (navigator.userAgent.indexOf("Firefox") > -1) {
        return "Mozilla Firefox";
      } 
      else if (navigator.userAgent.indexOf("SamsungBrowser") > -1) {
        return "Samsung Internet";
      } 
      else if (navigator.userAgent.indexOf("Opera") > -1 || navigator.userAgent.indexOf("OPR") > -1) {
        return "Opera";
      } 
      else if (navigator.userAgent.indexOf("Trident") > -1) {
        return "Internet Explorer";
      } 
      else if (navigator.userAgent.indexOf("Edge") > -1) {
        return "Microsoft Edge";
      } 
      else if (navigator.userAgent.indexOf("Chrome") > -1) {
        return "Google Chrome";
      } 
      else if (navigator.userAgent.indexOf("Safari") > -1) {
        return "Safari";
      } 
      else {
        return "Unknown Browser";
      }
} 

export default BrowserDetect;